import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/button';
import Link from 'components/link';

const LoginModal = ({ links, registerLink, registerLinkLabel, title }) => (
  <div className="login-modal">
    <h2>{title}</h2>
    {links.map(link => (
      <div className="login-modal-link-wrapper" key={link.label}>
        <p>{link.label}</p>
        <Button
          className="login-modal-button"
          theme={[Button.themes.orange, Button.themes.uppercase]}
          {...link.link}
        />
      </div>
    ))}
    <div className="login-modal-register">
      <p>{registerLinkLabel}</p>
      <Link className="login-modal-register-link" {...registerLink} />
    </div>
  </div>
);

LoginModal.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.exact({
      label: PropTypes.string,
      link: PropTypes.exact(Link.propTypes)
    })
  ),
  registerLink: PropTypes.exact(Link.propTypes),
  registerLinkLabel: PropTypes.string,
  title: PropTypes.string
};

LoginModal.defaultProps = {
  links: []
};

export default LoginModal;
